<template>
  <q-page> 
    <q-card>
      <q-card-title>
        <div class="row">
          <div class="col">
            {{$t('global.CostBill')}}
          </div>
           <div class="col">
             <q-btn color="primary" :label="$t('global.RecalculateRedistribute')" @click="recalc()" :loading="loading" />
          </div>
        </div> 
      </q-card-title>
    <q-card-main>
      <div class="row">
        <div class="col">
          <q-datetime v-model="dateFrom" type="date" :float-label="$t('global.DateFrom')" format="DD.MMM.YYYY"/>
        </div>
        <div class="col-1"></div>
        <div class="col">
          <q-datetime v-model="dateTo" type="date" :float-label="$t('global.DateTo')" format="DD.MMM.YYYY" />
        </div>
        <div class="col-1"></div>
        <div v-if="false" class="col">
          <q-select
            v-model="pList"
            :float-label="productLabel"
            :options="optionsProduct"  
            multiple
            chips
            ref="pList"
          />  
        </div>
      </div>
      <img v-if="repLoaded == false" src="@/assets/load.gif">
      <div v-show="repLoaded" class="report">
        <iframe
         class="content-frame full-width "
          :src="repSource"
          frameborder="0"
          allowfullscreen
          @load="load"
          >
        </iframe>
      </div>
    </q-card-main>   
  </q-card>
  </q-page>
</template>
<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'

export default {

  data: function () {
    return {
      dateFrom: this.moment().startOf('year').toISOString(),
      dateTo:  this.moment().add(1, 'days').toISOString(),
      repLoaded: false,
      loading: false,
      pList: [],
      optionsProduct: [{value: 1, label: 'Wein1'},{value: 2, label: 'Wein2'}, {value: 3, label: 'Wein3'}],
      repRunDummy: 0,
      form: {
        SessionId: null,
      }, 
    }
  },
  methods: {
		load: function(){
      //stop report loading grafic when report is ready
      this.repLoaded = true
    }, 
    recalc(){
      this.loading = true
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "recalcCostBill"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.loading = false
              this.repRunDummy++
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadProduct(){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getProduct"
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = response.data
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },

  },
  computed:{
      repSource () {
        var dFrom = date.formatDate(this.dateFrom, 'YYYY-MM-DD')   
        var dTo = date.formatDate(this.dateTo, 'YYYY-MM-DD')
        var dummy = this.repRunDummy
        var pListText = ""
        if(this.$refs.pList != undefined)
          pListText = this.$refs.pList.actualValue //Send this as texts for titels later
  
        return this.$reportUrl + "/WorkTime.aspx?sid=" + this.$store.state.session.SessionId + "&dateFrom=" + dFrom + "&dateTo=" + dTo +"&repid=" + this.$route.params.repid + "&locale=" + this.$i18n.locale + "&dummy=" + dummy + "&plist=" + this.pList + "&plisttext=" + pListText
      },
      productLabel (){
        if(this.pList.length == 0)
          return this.$t('global.AllProducts')
        else
          return this.$t('global.Product')
      }
  },
  created () {
    this.loadProduct()
  },
  watch: {
    repSource: function (val) {
      this.repLoaded = false
    },
  }
}
</script>
<style scoped>
.content-frame{
  height: calc(100vh - 255px);
  width: 100%;
}
</style>

